export enum ButtonPropsColor {
  Main = "#6462F3",
  Clilac = "#EAE9FF",
  Gray = "#EBEBEB",
  Gray1 = "#F6F6F6",
  Gray4 = "#919CA5",
  Green = "#36CE91",
  Red = "#F15857",
  None = "transparent"
}
